import React, {Component} from 'react';

import ResponsiveLayout from '../common/ResponsiveLayout';

import memberStar from "../../img/ic-member.svg";
import distanceIcon from "../../img/ic-distance-large.svg";
import unverifiedIcon from '../../img/ic-unverified-location-small.svg';

import '../../css/LocatorResult.css';

const mileRatio = 0.621371;

class LocatorResultDesktopLayout extends Component {
    render() {
        return (
            <div className="locator-result-container" onMouseOver={this.props.onMouseOver} onClick={this.props.onClick}>
                <div className="locator-result-main">
                    {this.props.result.isPreferred ?
                        <div className="locator-result-preferred-member">
                            <img className="locator-result-preferred-member-image" src={memberStar} alt="preferred member star"/> Sponsored
                        </div>
                        :
                        null
                    }
                    <div className="locator-result-name">
                        {this.props.result.name}
                    </div>
                    <div className="locator-result-distance">
                        <img className="distanceIcon" src={distanceIcon} alt="distance icon" />{this.props.formatMiles()}
                    </div>
                    <div className="locator-result-address" onClick={this.onAddressClick}>
                        <div>{this.props.result.address1}</div>
                        <div>{this.props.result.city}, {this.props.result.stateAbbr}</div>
                    </div>
                    {!this.props.result.orgId ?
                        <div>
                            <div className="locator-result-unverified">
                                <img src={unverifiedIcon} style={{marginRight: "5px"}} alt="unclaimed icon" /> Unclaimed
                            </div>
                        </div>
                        :
                        null
                    }
                </div>
                {this.props.result.temporarily_closed ?
                    <div className="locator-result-temporarily-closed">
                        Temporarily Closed
                    </div>
                    :
                    null
                }
            </div>
        )
    }
}

class LocatorResultMobileLayout extends Component {
    getImageUrl = () => {
        var location = [this.props.result.address1, this.props.result.city, this.props.result.stateAbbr].join(", ");
        var size = [window.innerWidth, Math.floor(window.innerWidth / 2)].join("x");
        var imageSrc = "https://maps.googleapis.com/maps/api/streetview?size=" + size + "&location=" + location + "&key=AIzaSyApSGBeZg_jMxvPCItA4b5JJdEvNcUqbyM";
        if (this.props.result.photos && this.props.result.photos.length) {
            imageSrc = this.props.result.photos[0];
        }
        return imageSrc;
    }

    render() {
        return (
            <div style={{display: "flex", flexDirection: "column", height: "100%", position: "relative"}} onClick={this.props.onClick}>
                <div className="locator-result-background-image">
                    <div className="locator-result-background-overlay"></div>
                    <div className="locator-result-name">
                        {this.props.result.name}
                    </div>
                </div>
                <div className="locator-result-content">
                    {this.props.result.isPreferred ?
                        <div className="locator-result-preferred-member">
                            <img className="locator-result-preferred-member-image" src={memberStar} alt="member star"/> Sponsored
                        </div>
                        :
                        null
                    }
                    <div className="locator-result-distance">
                        <img className="distanceIcon" src={distanceIcon} alt="distance icon"/>{this.props.formatMiles()}
                    </div>
                    <div className="locator-result-address" onClick={this.onAddressClick}>
                        <div>{this.props.result.address1}</div>
                        <div>{this.props.result.city}, {this.props.result.stateAbbr}</div>
                    </div>
                    {!this.props.result.orgId ?
                        <div>
                            <div className="locator-result-unverified">
                                <img src={unverifiedIcon} style={{marginRight: "5px"}} alt="unclaimed icon" /> Unclaimed
                            </div>
                        </div>
                        :
                        null
                    }
                </div>
                {this.props.result.temporarily_closed ?
                    <div className="locator-result-temporarily-closed">
                        Temporarily Closed
                    </div>
                    :
                    null
                }
            </div>
        );
    }
}

class LocatorResult extends Component {

    formatMiles = () => {
        var miles = mileRatio * this.props.result.distance;
        return miles.toFixed() + " miles";
    }

    onAddressClick = () => {
        // KBM - UX is pretty confusing. Let's figure out something else
        // window.open("https://maps.google.com?saddr=Current+Location&daddr=" +
        //     this.props.latitude + "," + this.props.longitude, "_target=blank");
    }

    render() {
        return (
            <ResponsiveLayout
                desktopLayout={LocatorResultDesktopLayout}
                mobileLayout={LocatorResultMobileLayout}
                {...this.props}
                formatMiles={this.formatMiles} />
        )
    }
}

export default LocatorResult;



// WEBPACK FOOTER //
// ./src/components/locator/LocatorResult.js